import { render, staticRenderFns } from "./AntecedenteComponent.vue?vue&type=template&id=33678e92"
import script from "./AntecedenteComponent.vue?vue&type=script&lang=js"
export * from "./AntecedenteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports